!(function (e) {
  var t,
    n,
    d,
    o,
    i,
    a,
    r =
      '<svg><symbol id="config" viewBox="0 0 48 48" fill="none"><path data-follow-stroke="currentColor" d="m24 4-6 6h-8v8l-6 6 6 6v8h8l6 6 6-6h8v-8l6-6-6-6v-8h-8l-6-6Z" stroke="currentColor" stroke-width="4" stroke-linejoin="round"/><path data-follow-stroke="currentColor" d="M24 30a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z" stroke="currentColor" stroke-width="4" stroke-linejoin="round"/></symbol><symbol id="bookmark-one" viewBox="0 0 48 48" fill="none"><path stroke-linejoin="round" stroke-linecap="round" stroke-width="4" stroke="currentColor" d="M34 10V4H8v34l6-3" data-follow-stroke="currentColor"/><path stroke-linejoin="round" stroke-width="4" stroke="currentColor" d="M14 44V10h26v34l-13-6.273L14 44Z" data-follow-stroke="currentColor"/></symbol><symbol id="laptop-computer" viewBox="0 0 48 48" fill="none"><rect stroke-width="4" stroke="currentColor" rx="2" height="24" width="38" y="8" x="5" data-follow-stroke="currentColor"/><path stroke-linejoin="round" stroke-linecap="round" stroke-width="4" stroke="currentColor" d="M4 40h40M22 14h4" data-follow-stroke="currentColor"/></symbol></svg>';
  function c() {
    i || ((i = !0), d());
  }
  (t = function () {
    var e, t, n;
    ((n = document.createElement("div")).innerHTML = r),
      (r = null),
      (t = n.getElementsByTagName("svg")[0]) &&
        (t.setAttribute("aria-hidden", "true"),
        (t.style.position = "absolute"),
        (t.style.width = 0),
        (t.style.height = 0),
        (t.style.overflow = "hidden"),
        (e = t),
        (n = document.body).firstChild
          ? (t = n.firstChild).parentNode.insertBefore(e, t)
          : n.appendChild(e));
  }),
    document.addEventListener
      ? ["complete", "loaded", "interactive"].indexOf(document.readyState) > -1
        ? setTimeout(t, 0)
        : ((n = function () {
            document.removeEventListener("DOMContentLoaded", n, !1), t();
          }),
          document.addEventListener("DOMContentLoaded", n, !1))
      : document.attachEvent &&
        ((d = t),
        (o = e.document),
        (i = !1),
        (a = function () {
          try {
            o.documentElement.doScroll("left");
          } catch (e) {
            return void setTimeout(a, 50);
          }
          c();
        })(),
        (o.onreadystatechange = function () {
          "complete" == o.readyState && ((o.onreadystatechange = null), c());
        }));
})(window);
